import revokeTokenHandler from '../../pattern_utilities/revokeTokenHandler';
import { push } from 'react-router-redux';

var pf_config = require('../../pf_config.json');
var Cookies = require('js-cookie');

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// CHANGE THEME
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////


export const requestUpdateTeamTheme = credentials => {
  return {
    type: 'REQUEST_UPDATE_TEAM_THEME',
    data: {
      lastSubmit: credentials
    }
  }
}

export const receiveUpdateTeamThemeSuccess = data => ({
  type: 'RECEIVE_UPDATE_TEAM_THEME_SUCCESS',
  data
})

export const receiveUpdateTeamThemeFail = data => ({
  type: 'RECEIVE_UPDATE_TEAM_THEME_FAIL',
  data
})

export const tryToUpdateTeamTheme = packet => dispatch => {
  dispatch(requestUpdateTeamTheme(packet));
  
  return fetch('/api/teams/change-theme/' + packet.id, {
      method: 'put',
      body: JSON.stringify(packet),
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + Cookies.get(process.env.REACT_APP_COOKIE_AUTH)
      }
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveUpdateTeamThemeSuccess(json));
    })
    .catch(e => {
      revokeTokenHandler(e);
      dispatch(receiveUpdateTeamThemeFail({errors:e, lastSubmit: packet}));
    })
}


// WEBPACK FOOTER //
// ./src/actions/team/a.t.PUT.change-theme.js